import React from 'react';
import { Link } from 'react-router-dom';

interface PaginationProps {
  page: number;
  totalPages: number;
}

const linkClass = 'text-primary-gold hover:text-white transition-colors';

const Pagination: React.FC<PaginationProps> = ({ page, totalPages }) => {
  if (totalPages <= 1) return null;
  return (
    <nav aria-label="Pagination" className="mt-10 flex items-center justify-center gap-8">
      {page > 1 && (
        <Link className={linkClass} to={page === 2 ? '/news' : `/news/page/${page - 1}`}>
          Previous
        </Link>
      )}
      <span className="text-gray-400 text-sm">Page {page} of {totalPages}</span>
      {page < totalPages && (
        <Link className={linkClass} to={`/news/page/${page + 1}`}>
          Next
        </Link>
      )}
    </nav>
  );
};

export default Pagination;
